export class Tax{
    refNo:number;
    taxName:string;
    taxRate:number;
}